export default __webpack_public_path__ + "static/media/Insert_PartingLine.015e1cc2.svg";